export const isScmQuoteOnlyTags = (
  tags: string[] | null | undefined,
): boolean => Array.isArray(tags) && tags.includes("SCMQUOTE");
